import { render, staticRenderFns } from "./PriceOfProduct.vue?vue&type=template&id=1bedce86"
import script from "./PriceOfProduct.vue?vue&type=script&lang=js"
export * from "./PriceOfProduct.vue?vue&type=script&lang=js"
import style0 from "./PriceOfProduct.vue?vue&type=style&index=0&id=1bedce86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports